import * as ACTION from 'actions';

export function serialCodeData(state=[], action) {
    if (action == null) return state;

    switch (action.type) {
        case ACTION.FETCH_SERIAL_CODE_DATA:
            return action.serialCodeData;
        default:
            return state
    }
}
